import React from 'react';
import ".././css/priceCards.css"
import Tilt from "react-parallax-tilt";
import { LinkComponent } from './Utilities';




  




function PriceCard(props) {


    return (
        
        // https://www.npmjs.com/package/react-parallax-tilt
        <div className="cardContainer">
            <Tilt    
            className="parallax-effect-glare-scale"
            perspective={1000}
            glareEnable={true}
            glareMaxOpacity={0.6}
            scale={1.02}
            glareColor="#ffffff"
            glarePosition="all"
            tiltReverse={true}
            >
                <div className="card" style={{background: props.color}}>
                    <div class="image">
                        
                        <img src={process.env.PUBLIC_URL + '/' + props.image + '.png'} alt="" />
                    </div>
                    <div className="about">
                        {props.text1}
                    </div>
                    <div className="price">
                        {props.text2}
                    </div>
                    <div className="read-more">
                        <button variant="contained" color="primary" component={LinkComponent} to="/pages/faq">Se priser!</button>
                    </div>
                </div>
            </Tilt>
        </div>
        
  );
}

export default PriceCard;